import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'sc-wrapper-car',
  templateUrl: './wrapper-car.component.html',
  styleUrls: ['./wrapper-car.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WrapperCarComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
